import LocalStorageFactory from '@/factories/local-storage-factory'
import PubSub from '@/pubsub'

const get = async (url, headers = {}, attachAccessToken = true) => {
  try {
    const option = {
      method: 'GET'
    }

    const res = await _fetchData(url, option, headers, attachAccessToken)

    return res.json()
  } catch (err) {
    throw err
  }
}

const getBlob = async (url, headers = {}, attachAccessToken = true) => {
  try {
    const option = {
      method: 'GET'
    }

    const res = await _fetchData(url, option, headers, attachAccessToken)

    return res.blob()
  } catch (err) {
    throw err
  }
}

const put = async (url, data, headers = {}, attachAccessToken = true) => {
  try {
    const option = {
      method: 'PUT',
      body: JSON.stringify(data)
    }

    const res = await _fetchData(url, option, headers, attachAccessToken)

    return res.json()
  } catch (err) {
    throw err
  }
}

const post = async (url, data, headers = {}, attachAccessToken = true) => {
  try {
    const option = {
      method: 'POST',
      body: JSON.stringify(data)
    }

    const res = await _fetchData(url, option, headers, attachAccessToken)

    return res.json()
  } catch (err) {
    throw err
  }
}

const remove = async (url, data = {}, headers = {}, attachAccessToken = true) => {
  try {
    const option = {
      method: 'DELETE',
      body: JSON.stringify(data)
    }

    const res = await _fetchData(url, option, headers, attachAccessToken)

    return res.json()
  } catch (err) {
    throw err
  }
}

const _fetchData = async (url, option = null, headers = {}, attachAccessToken = true) => {
  const defaultHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }

  const authorizationHeader = (attachAccessToken === true) ? { 'Authorization': LocalStorageFactory.getToken() } : {}
  const mergeHeaders = Object.assign(defaultHeaders, headers, authorizationHeader)
  option.headers = mergeHeaders

  // const res = await fetch(url, option)
  let res
  try {
    res = await fetch(url, option)
  } catch (err) {
    throw new Error('Cannot connect to server, please check your internet connection.')
  }

  await _validateHTTPStatusSuccess(res)

  return res
}

const _validateHTTPStatusSuccess = async (res) => {
  const regExp = /(2[0-9][0-9])/
  const isSuccess = regExp.test(String(res.status))

  if (res.status === 401) {
    PubSub.publish(PubSub.EVENT.UNAUTHORIZED)

    const err = new Error('Session expired')
    throw err
  } else if (res.status === 302) {
    throw await res.json()
  } else if (!isSuccess) {
    const err = await _handleError(res)
    throw err
  }
}

const _handleError = async (res) => {
  let response

  try {
    response = await res.json()
  } catch (err) {
    throw new Error('An unknown error has occurred, Please contact your admin.')
  }

  const err = new Error(response.error)
  err.status = res.status

  return err
}

export default {
  get,
  getBlob,
  post,
  put,
  remove
}
